import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Constants } from '../shared/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../auth/auth.service';
import { SiteminderAuthService } from '../auth/oidc-config.service';
import { LogoutServive } from '../logout/logout.service';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { GlobalsessionhandlerService } from '../shared/services/globalsessionhandler.service';
import { NotificationService } from '../shared/services/notifications.service';
import { TokenStorageService } from '../shared/services/token-storage.service';
import { Token } from '@angular/compiler';
@Component({
  selector: 'app-odp-login',
  templateUrl: './odp-login.component.html',
  styleUrl: './odp-login.component.scss'
})
export class OdpLoginComponent {
  
  siteminderToken: string = "";
  UserLoggedIn: boolean = false;
  constant: Constants = new Constants();
  routeSubScription: any

    constructor(private activatedRoute: ActivatedRoute, private baseHttpService: BaseHttpService, private router: Router,
      private notificationService: NotificationService, private authService: AuthService,
      private logoutservice: LogoutServive,private oidcservice : SiteminderAuthService,
      private globalsessionhandler: GlobalsessionhandlerService, private spinnerService: NgxSpinnerService, private tokenStorage: TokenStorageService)
       {
      this.activatedRoute.queryParams.subscribe(params => {
        console.log('url', params.code); // Print the parameter to the console.
        // this.authService.getUserDataFromToken(params.code).subscribe((response:any)=>{
        //   console.log(response)
        // })
        this.getUserData(params.code)
      });
}
  async loadAccessPermission() {
    this.globalsessionhandler.clearSession();
    //await this.authorization.initializePermissions();
  }
async getUserData(accessToken:any): Promise<void> {
  try {
    const result:any = await this.authService.getUserData(accessToken);
    if (result != null) {
            this.tokenStorage.saveToken(result.auth_token);
            this.tokenStorage.saveRefreshToken(result.refresh_token);
            this.tokenStorage.saveUser(result);


            let token = result.auth_token;
            sessionStorage.setItem("token", result.auth_token);
            sessionStorage.setItem("refresh_token", result.refresh_token);
            this.globalsessionhandler.clearSession();
            this.notificationService.showSuccess("You have successfully logged in.", "Login successful!");
            this.loadAccessPermission().then(x => {
              this.globalsessionhandler.emitloginSucessful(true);
              // this.router.navigate(["./shared/components/menu-navbar"]);
              // this.router.navigate(["/admin/useractivity"]);
            this.router.navigate(["/reports"]);
            })
            this.UserLoggedIn = true;
            this.logoutservice.changeMessage(this.UserLoggedIn);    
          }
          else{
            this.notificationService.showError("Invalid Access Token","login failed");
            this.authService.removeToken();
            this.UserLoggedIn = false;
          }
    console.log('User:', result);
  } catch (error) {
    this.notificationService.showError("Invalid Access Token","login failed");
  }
}
}
